import React from 'react';
import ReactDOM from 'react-dom/client';
import './api';

import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import '././assets/css/icofont.min.css';
import '././assets/css/animate.css';
import '././assets/css/style.min.css';
import '././assets/css/style.min.css'

//import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <Router> */}
      
      <App />
    {/* </Router> */}
  </React.StrictMode>
);

// ReactDOM.hydrate(
//   <React.StrictMode>
//     <Router>
//       <ScrollToTop />
//       <App />
//     </Router>
//   </React.StrictMode>
//   , document.getElementById('root'));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

